import { isMobile } from '@polyv/utils/src/browser';

export default {
  data() {
    return {
      // 记录浏览过的商品 id
      recordBrowseId: {},
    };
  },

  methods: {
    /**
     * 检查商品浏览状态
     */
    async checkBrowseProduct() {
      this.$nextTick(() => {
        const $productContent = this.$refs.productContent;
        const scrollTop = $productContent.scrollTop;
        const scrollClientHeight = $productContent.clientHeight;
        const items = this.$refs.productItem;

        if (!items) {
          return;
        }

        items.forEach((vm) => {
          const productId = vm.good.productId;

          const $el = vm.$el;
          const offsetTop = $el.offsetTop;
          const offsetHeight = $el.offsetHeight;
          // 是否超出顶部
          const overTop = scrollTop > (offsetTop + offsetHeight);
          // 是否超出底部
          const overBottom = (scrollClientHeight + scrollTop) < (offsetTop + offsetHeight);

          // 回调过一次就不需要再回调
          if (!overTop && !overBottom && !this.recordBrowseId[productId]) {
            this.recordBrowseId[productId] = true;
            this.$emit('browse-product', vm.good);
            const trackLogData = {
              event_cata: 'behavior',
              event_type: 'show',
              event_id: 'product_list_item_view',
              spec_attrs: Object.assign({
                exposureTime: new Date().getTime(),
                linkType: isMobile() ? 'mobile' : 'pc',
                name: vm.good.name,
                price: vm.good.price,
                productId: vm.good.productId,
                productType: vm.good.productType,
                realPrice: vm.good.realPrice,
                productFeature: vm.good.features,
              }, vm.good, { linkType: isMobile() ? 'mobile' : 'pc' })
            };
            // 需要对齐线上商品库埋点字段 linkType
            this.productSdk.trackLog(trackLogData);
          }
        });
      });
    },

    clearBrowseProduct() {
      this.recordBrowseId = {};
    },
  },
};
